import React, { useState } from "react";

import { DVIRQuestionsTab, DVIRTemplatesTab, DVIRReportsTab } from "../../components";
import {
  AddQuestionModal,
  DeleteQuestionModal,
  EditQuestionModal,
  AddTemplateModal,
  DeleteTemplateModal,
  EditTemplateModal,
  DeleteReportModal,
  AddReportModal,
  ViewReportModal,
} from "../../modals";

import "./DVIRManagementView.scss";

export function DVIRManagementView() {
  const [activeTab, setActiveTab] = useState("reports");

  const tabs = [
    { id: "reports", label: "DVIR Reports", component: DVIRReportsTab },
    { id: "templates", label: "Templates", component: DVIRTemplatesTab },
    { id: "questions", label: "Questions", component: DVIRQuestionsTab },
  ];

  const renderTabContent = () => {
    const activeTabConfig = tabs.find((tab) => tab.id === activeTab);
    if (!activeTabConfig) return null;

    const Component = activeTabConfig.component;
    return <Component />;
  };

  return (
    <div className="dvir-management-component">
      <div className="header">
        <h1>DVIR Management System</h1>
      </div>

      <div className="nav-tabs">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`nav-tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </div>
        ))}
      </div>

      <div className="container">{renderTabContent()}</div>

      <AddQuestionModal />
      <DeleteQuestionModal />
      <EditQuestionModal />
      <AddTemplateModal />
      <DeleteTemplateModal />
      <EditTemplateModal />
      <DeleteReportModal />
      <AddReportModal />
      <ViewReportModal />
    </div>
  );
}
